import Vue from 'vue'
import VueRouter from 'vue-router'
import Programacao from '../views/Programacao.vue'
import User from '../user/User.vue'

Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name: 'Programacao',
    component: Programacao
  },
  {
    path: '/palestrantes',
    name: 'Palestrantes',
    component: () => import(/* webpackChunkName: "programacao" */ '../views/Palestrantes.vue')
  },
  {
    path: '/programacao-lista',
    name: 'Programação em Lista',
    component: () => import(/* webpackChunkName: "programacaoLista" */ '../views/ProgramacaoLista.vue')
  },
  {
    path: '/minha-agenda',
    name: 'Minha Agenda',
    component: () => import(/* webpackChunkName: "MinhaAgenda" */ '../views/MinhaAgenda.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue')
  },
  {
    path: '/user/:action/:email?/:token?',
    name: 'User Authentication',
    component: User,
    props: true
  }
]


const router = new VueRouter({
  base: process.env.VUE_APP_BASE,
  routes
})

export default router
